type DetailedError = Error & {
  details?: string;
  shortMessage?: string;
};

const rejectedPatterns = [
  /user rejected/i,
  /user denied/i,
  /rejected the request/i,
  /request rejected/i,
  /code[": ]+4001/i,
];

export function isUserRejectedError(error: unknown) {
  const message = error instanceof Error ? error.message : String(error || "");
  return rejectedPatterns.some((pattern) => pattern.test(message));
}

export function readableError(error: unknown, fallback: string) {
  if (!(error instanceof Error)) return fallback;

  const detailed = error as DetailedError;
  const candidate = detailed.shortMessage || detailed.details || error.message;
  const firstParagraph = candidate.split(/\n\s*\n|\nDetails:/i)[0]?.trim();
  if (!firstParagraph) return fallback;
  if (rejectedPatterns.some((pattern) => pattern.test(firstParagraph))) {
    return "The request was rejected in the wallet.";
  }
  return firstParagraph.length > 280
    ? `${firstParagraph.slice(0, 277).trimEnd()}…`
    : firstParagraph;
}
